import { SnapshotImage } from 'src/types';

export function detectDummyImage(roomImages: SnapshotImage[]) {
  const firstImage = roomImages[0];
  return roomImages.length === 1 && !firstImage.url && !firstImage.importedUrl;
}
